import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeNamePipe } from '@coin/shared/core/util-pipes';
import { Comment } from '../v2-comments.component';
import { EmployeePictureComponent } from '../../employee-picture/employee-picture.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'coin-v2-comment',
  imports: [CommonModule, EmployeeNamePipe, EmployeePictureComponent, TranslateModule],
  templateUrl: './v2-comment.component.html',
  styleUrl: './v2-comment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.own-comment]': 'isOwnComment()'
  }
})
export class V2CommentComponent {
  comment = input.required<Comment>();
  isOwnComment = input<boolean>(false);
  commentExtension = input<TemplateRef<unknown>>();
}
